// チームリーグ詳細画面のタブ切替
$(document).on('turbolinks:load', function() {
  // 順位表・グラフのタブ切替（チーム/個人）
  $(document).on('click', '.league-ranking-tab', function() {
    var target = $(this).data('target');
    // タブのactive切替
    $(this).siblings('.league-ranking-tab').removeClass('active');
    $(this).addClass('active');
    // パネルのactive切替
    $(this).closest('.content-card').find('.league-ranking-panel').removeClass('active');
    $('#' + target).addClass('active');
    // 順位表タイトルをタブに応じて切替（ロケール依存文言はdata属性経由でHAMLから受け取る）
    var $rankingTitle = $('#ranking-title');
    var title = target === 'team-panel' ? $rankingTitle.data('label-team') : $rankingTitle.data('label-individual');
    $rankingTitle.text(title);
  });

  // チーム順位表の行クリック
  $(document).on('click', '#team-rank-table tbody tr', function() {
    var href = $(this).data('href');
    if (href) {
      window.location.href = href;
    }
  });
});
